import * as constants from "./constants";

// Fetch decisions list
export const fetchDecisionsRequest = (params?: any) => ({
    type: constants.FETCH_DECISIONS_REQUESTING, params,
});
export const fetchDecisionsSuccess = (payload: any) => ({
    type: constants.FETCH_DECISIONS_SUCCESS, payload,
});
export const fetchDecisionsFailed = (error: any) => ({
    type: constants.FETCH_DECISIONS_FAILED, error,
});

// Fetch decision detail
export const fetchDecisionDetailRequest = (id: string) => ({
    type: constants.FETCH_DECISION_DETAIL_REQUESTING, id,
});
export const fetchDecisionDetailSuccess = (payload: any) => ({
    type: constants.FETCH_DECISION_DETAIL_SUCCESS, payload,
});
export const fetchDecisionDetailFailed = (error: any) => ({
    type: constants.FETCH_DECISION_DETAIL_FAILED, error,
});
export const clearDecisionDetail = () => ({
    type: constants.CLEAR_DECISION_DETAIL,
});

// Create decision (manual)
export const createDecisionRequest = (payload: any, callback?: () => void) => ({
    type: constants.CREATE_DECISION_REQUESTING, payload, callback,
});
export const createDecisionSuccess = (payload: any) => ({
    type: constants.CREATE_DECISION_SUCCESS, payload,
});
export const createDecisionFailed = (error: any) => ({
    type: constants.CREATE_DECISION_FAILED, error,
});

// Update decision
export const updateDecisionRequest = (id: string, payload: any, callback?: () => void) => ({
    type: constants.UPDATE_DECISION_REQUESTING, id, payload, callback,
});
export const updateDecisionSuccess = (payload: any) => ({
    type: constants.UPDATE_DECISION_SUCCESS, payload,
});
export const updateDecisionFailed = (error: any) => ({
    type: constants.UPDATE_DECISION_FAILED, error,
});

// Delete decision
export const deleteDecisionRequest = (id: string, callback?: () => void) => ({
    type: constants.DELETE_DECISION_REQUESTING, id, callback,
});
export const deleteDecisionSuccess = (id: string) => ({
    type: constants.DELETE_DECISION_SUCCESS, id,
});
export const deleteDecisionFailed = (error: any) => ({
    type: constants.DELETE_DECISION_FAILED, error,
});

// Upload PDF files
export const uploadDecisionsRequest = (files: File[], callback?: (results: any) => void) => ({
    type: constants.UPLOAD_DECISIONS_REQUESTING, files, callback,
});
export const uploadDecisionsSuccess = (payload: any) => ({
    type: constants.UPLOAD_DECISIONS_SUCCESS, payload,
});
export const uploadDecisionsFailed = (error: any) => ({
    type: constants.UPLOAD_DECISIONS_FAILED, error,
});

// Workflow actions (soumettre, valider, publier, rejeter, anonymiser)
export const workflowActionRequest = (
    id: string,
    action: 'soumettre' | 'valider' | 'publier' | 'rejeter' | 'anonymiser' | 'remettre_en_verification',
    callback?: () => void,
) => ({
    type: constants.WORKFLOW_ACTION_REQUESTING, id, action, callback,
});
export const workflowActionSuccess = (payload: any) => ({
    type: constants.WORKFLOW_ACTION_SUCCESS, payload,
});
export const workflowActionFailed = (error: any) => ({
    type: constants.WORKFLOW_ACTION_FAILED, error,
});

// Pipeline polling
export const pollHistoriquesUpdate = (decisionId: string, steps: any[]) => ({
    type: constants.POLL_HISTORIQUES_UPDATE, decisionId, steps,
});

// Dashboard stats
export const fetchStatsRequest = () => ({
    type: constants.FETCH_STATS_REQUESTING,
});
export const fetchStatsSuccess = (payload: any) => ({
    type: constants.FETCH_STATS_SUCCESS, payload,
});
export const fetchStatsFailed = (error: any) => ({
    type: constants.FETCH_STATS_FAILED, error,
});

// Admin dashboard
export const fetchAdminDashboardRequest = () => ({
    type: constants.FETCH_ADMIN_DASHBOARD_REQUESTING,
});
export const fetchAdminDashboardSuccess = (payload: any) => ({
    type: constants.FETCH_ADMIN_DASHBOARD_SUCCESS, payload,
});
export const fetchAdminDashboardFailed = (error: any) => ({
    type: constants.FETCH_ADMIN_DASHBOARD_FAILED, error,
});

// Pipeline
export const fetchPipelineRequest = (params?: any) => ({
    type: constants.FETCH_PIPELINE_REQUESTING, params,
});
export const fetchPipelineSuccess = (payload: any) => ({
    type: constants.FETCH_PIPELINE_SUCCESS, payload,
});
export const fetchPipelineFailed = (error: any) => ({
    type: constants.FETCH_PIPELINE_FAILED, error,
});

// Reassign
export const reassignDecisionsRequest = (payload: any, callback?: () => void) => ({
    type: constants.REASSIGN_DECISIONS_REQUESTING, payload, callback,
});
export const reassignDecisionsSuccess = (payload: any) => ({
    type: constants.REASSIGN_DECISIONS_SUCCESS, payload,
});
export const reassignDecisionsFailed = (error: any) => ({
    type: constants.REASSIGN_DECISIONS_FAILED, error,
});

// Super-admin dashboard
export const fetchSuperAdminDashboardRequest = () => ({
    type: constants.FETCH_SUPERADMIN_DASHBOARD_REQUESTING,
});
export const fetchSuperAdminDashboardSuccess = (payload: any) => ({
    type: constants.FETCH_SUPERADMIN_DASHBOARD_SUCCESS, payload,
});
export const fetchSuperAdminDashboardFailed = (error: any) => ({
    type: constants.FETCH_SUPERADMIN_DASHBOARD_FAILED, error,
});
